module.exports = __webpack_public_path__ + "static/media/descargar.5e5f2e47.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/servicios/descargar.svg
// module id = 169
// module chunks = 0